

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {ThongTinLaoDong} from "@/models/thongTinLaoDong";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoYTeLaoDongTuyenHuyen} from "@/models/baoCaoYTeLaoDongTuyenHuyen";
import {TongSoMau} from "@/models/tongSoMau";
import {BaoCaoKetQuaHoatDongYTKDThang} from "@/models/baoCaoKetQuaHoatDongYTKDThang";
import {BaoCaoKetQuaHoatDongYTKD6Thang} from "@/models/baoCaoKetQuaHoatDongYTKD6Thang";
import {BaoCaoKetQuaHoatDongYTKDTuan} from "@/models/baoCaoKetQuaHoatDongYTKDTuan";
import {BaoCaoKetQuaHoatDongYTKDNam} from "@/models/baoCaoKetQuaHoatDongYTKDNam";
import {ListWeekInYear} from "@/models/listWeekInYear";
import { BaoCaoKetQuaHoatDongYTKDNgay } from '@/models/baoCaoKetQuaHoatDongYTKDNgay';
import {DanhSachTuan} from "@/models/danhSachTuan";
import {ThoiGian} from "@/models/thoiGian";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const dateWeek = ref();
    const date6Month = ref();
    const tuan = ref({} as DanhSachTuan)
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoKetQuaHoatDongYTKDThang);
    const baoCao6Thang = ref({} as BaoCaoKetQuaHoatDongYTKD6Thang);
    const baoCaoTuan = ref({} as BaoCaoKetQuaHoatDongYTKDTuan);
    const baoCaoNam = ref({} as BaoCaoKetQuaHoatDongYTKDNam);
    const baoCaoNgay = ref({} as BaoCaoKetQuaHoatDongYTKDNgay);
    const listWeek = ref([] as ListWeekInYear[]);
    const selection = ref(0);
    const listSelection = ref([
      {label: "Sân bay quốc tế  Đà Nẵng ", value: "sanbay", param: 1},
      {label: "Cảng Đà Nẵng", value: "cangquocte", param: 2},
      {label: "Tất cả", value: "tatca", param: 0},
    ]);
    const dateYear = ref();
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCao.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
      baoCao.value.cuaKhauHangHoas = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, buuPham: {}, hangHoaKhac: {}},
      ];
      
      baoCao.value.cuaKhauThiThes = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, thiThe: {}, haiCot: {}, troCot: {}},
      ];
      baoCao.value.cuaKhauViSinhs = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
      ];
//// bao cao 6 thang////


      baoCaoNam.value.cuaKhauDoiVoiNguois =
      baoCaoNgay.value.cuaKhauDoiVoiNguois =
      baoCao6Thang.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCaoNam.value.cuaKhauPhuongTiens =
      baoCaoNgay.value.cuaKhauPhuongTiens =
      baoCao6Thang.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
      baoCaoNam.value.cuaKhauHangHoas =
      baoCaoNgay.value.cuaKhauHangHoas =
      baoCao6Thang.value.cuaKhauHangHoas = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, buuPham: {}, hangHoaKhac: {}},
      ];

      baoCaoNam.value.cuaKhauThiThes =
      baoCaoNgay.value.cuaKhauThiThes =
      baoCao6Thang.value.cuaKhauThiThes = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, thiThe: {}, haiCot: {}, troCot: {}},
      ];
      baoCaoNam.value.cuaKhauViSinhs =
      baoCaoNgay.value.cuaKhauViSinhs =
      baoCao6Thang.value.cuaKhauViSinhs = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
      ];
      baoCaoNam.value.tiemChungs =
      baoCaoNgay.value.tiemChungs =
      baoCao6Thang.value.tiemChungs = [
        {tenBenh: "Tả", tenVacxin: "Morcvax"},
      ];
      baoCaoNam.value.giamSatDichBenhs =
      baoCaoNgay.value.giamSatDichBenhs =
      baoCao6Thang.value.giamSatDichBenhs = [
        {tenCuaKhau: "Sân Bay quốc tế Đà Nẵng", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}},
        {tenCuaKhau: "Cảng Đà Nẵng", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}},
      ];
      baoCaoNam.value.xetNghiems =
      baoCaoNgay.value.xetNghiems =
      baoCao6Thang.value.xetNghiems = [
        {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      ];
      /// bao cao tuan

      baoCaoTuan.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCaoTuan.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
    }
    initDb();
    const addReport = () => {
      if(baoCao.value.tuNgay == null || baoCao.value.denNgay == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoYTeKiemDichThang(baoCao.value)
            .then((response) => {
              const temp = ref({} as BaoCaoKetQuaHoatDongYTKDThang);
              baoCao.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

 const addReport6Month = () => {
   if(baoCao6Thang.value.tuNgay == null || baoCao6Thang.value.denNgay == null)
   {
     toast.add({
       severity: 'error',
       summary: 'Lỗi',
       detail:'Vui lòng chọn thời gian báo cáo',
       life: 2000
     });
   }
   else {
     CDCRepository.createBaoCaoHDYTKD6Thang(baoCao6Thang.value)
         .then((response) => {
           const temp = ref({} as BaoCaoKetQuaHoatDongYTKD6Thang);
           baoCao6Thang.value = temp.value;
           initDb();
           toast.add({
             severity: 'success',
             summary: 'Thêm báo cáo',
             detail: 'Thêm báo cáo thành công vào hệ thống',
             life: 2000
           });
         })
         .catch(err => {
           toast.add({
             severity: 'error',
             summary: 'Lỗi',
             detail: err.response.data,
             life: 2000
           });
         });
   }
    }

    const addReportYear = () => {
   if(baoCaoNam.value.tuNgay == null || baoCaoNam.value.denNgay == null)
   {
     toast.add({
       severity: 'error',
       summary: 'Lỗi',
       detail:'Vui lòng chọn thời gian báo cáo',
       life: 2000
     });
   }
   else {
     CDCRepository.createBaoCaoHDYTKDNam(baoCaoNam.value)
         .then((response) => {
           const temp = ref({} as BaoCaoKetQuaHoatDongYTKDNam);
           baoCaoNam.value = temp.value;
           initDb();
           toast.add({
             severity: 'success',
             summary: 'Thêm báo cáo',
             detail: 'Thêm báo cáo thành công vào hệ thống',
             life: 2000
           });
         })
         .catch(err => {
           toast.add({
             severity: 'error',
             summary: 'Lỗi',
             detail: err.response.data,
             life: 2000
           });
         });
   }
    }

    const addReportDay = () => {
      if(baoCaoNgay.value.thoiGianBaoCao == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoHDYTKDNgay(baoCaoNgay.value)
            .then((response) => {
              const temp = ref({} as BaoCaoKetQuaHoatDongYTKDNgay);
              baoCaoNgay.value = temp.value;
              initDb();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const addReportWeek = () => {
      if(baoCaoTuan.value.tuNgay == null || baoCaoTuan.value.denNgay == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.createBaoCaoHDYTKDTuan(baoCaoTuan.value)
            .then((response) => {
              const temp = ref({} as BaoCaoKetQuaHoatDongYTKDTuan);
              baoCaoTuan.value = temp.value;
              initDb();
              getListWeek();
              toast.add({
                severity: 'success',
                summary: 'Thêm báo cáo',
                detail: 'Thêm báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const getListWeek = () => {
      console.log("####################@@@@@@@@@@@@@@@@@@@@@ getListWeek aaaa: ");
      console.log("####################@@@@@@@@@@@@@@@@@@@@@ getListWeek dateWeek.value: " + dateYear.value);
      console.log("####################@@@@@@@@@@@@@@@@@@@@@ getListWeek dateWeek.value.getFullYear(): " + dateYear.value.getFullYear());
        CDCRepository.showListWeekDontSend(dateYear.value.getFullYear())
            .then((response) => {
              listWeek.value = response.data;
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
    }

    const selectDay = () => {
         const t = ref({} as ThoiGian);
      t.value.time = baoCaoNgay.value.thoiGianBaoCao;
      CDCRepository.getWeek(t.value)
          .then((response) => {
            tuan.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }


    const addTiemChung = () => {
      baoCao6Thang.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSat = () => {
      baoCao6Thang.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiem = () => {
      // baoCao6Thang.value.xetNghiems = [
      //   {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      // ];
      baoCao6Thang.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const addTiemChungNgay = () => {
      baoCaoNgay.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSatNgay = () => {
      baoCaoNgay.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiemNgay = () => {
      // baoCao6Thang.value.xetNghiems = [
      //   {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      // ];
      baoCaoNgay.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const addTiemChungNam = () => {
      baoCaoNam.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSatNam = () => {
      baoCaoNam.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiemNam = () => {
      // baoCao6Thang.value.xetNghiems = [
      //   {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      // ];
      baoCaoNam.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };

    const selectWeek = () => {
      console.log("####################@@@@@@@@@@@@@@@@@@@@@ selectWeek aaaa: ");
      console.log("####################@@@@@@@@@@@@@@@@@@@@@ selectWeek   baoCaoTuan.value.id: " + baoCaoTuan.value.id);
      if(baoCaoTuan.value.id > 0)
      {
        listWeek.value.forEach(x => {
          if(x.id == baoCaoTuan.value.id)
          {
            baoCaoTuan.value.tuNgay = x.dateFrom;
            baoCaoTuan.value.denNgay = x.dateTo;
            baoCaoTuan.value.nam = dateYear.value.getFullYear();
            baoCaoTuan.value.tuan = x.id;
          }
        })
      }
    };

    return {
      date,
      service,
      baoCao,
      addReport,
      baoCao6Thang,
      addTiemChung,
      addGiamSat,
      addXetNghiem,
      addTiemChungNam,
      addGiamSatNam,
      addXetNghiemNam,
      addTiemChungNgay,
      addGiamSatNgay,
      addXetNghiemNgay,
      baoCaoTuan,
      addReportWeek,
      addReport6Month,
      addReportYear,
      addReportDay,
      dateWeek,
      date6Month,
      baoCaoNam,
      baoCaoNgay,
      dateYear,
      getListWeek,
      formatDateTime,
      listWeek,
      selectWeek,
      listSelection,
      selection,
      tuan,
      selectDay
    }
  }

}
